<div
  class="organisation-switcher clickable"
  (menuClosed)="updateDropdownState()"
  (menuOpened)="updateDropdownState()"
  [matMenuTriggerFor]="orgMenu"
  [class.no-top-border]="hasNoTopBorder"
>
  <div class="description" [tp]="currentOrganisation.name">
    {{ currentOrganisation.name }}
  </div>
  <mat-icon class="icon-20">keyboard_arrow_down</mat-icon>
</div>
<mat-menu #orgMenu="matMenu" class="organisation-menu">
  @if (!currentOrganisation.isSystemAdmin) {
    <button
      type="button"
      mat-menu-item
      class="has-icon create-organisation"
      (click)="createOrganisation()"
    >
      <mat-icon svgIcon="group-216" class="plus-icon"></mat-icon>
      <mat-icon class="add-organisation-icon">add</mat-icon>
      <ng-container i18n="@@action.addorganisation">Add organisation</ng-container>
    </button>
  }

  @for (organisation of sortedOrganisations(); track organisation.id) {
    <button
      type="button"
      class="organisation-button"
      mat-menu-item
      [class.active]="currentOrganisation.id === organisation.id"
      (click)="changeOrganisation(organisation.id)"
      [tp]="organisation.name"
      tpPlacement="right"
      [tpDelay]="500"
    >
      <div class="container-flex-space-between full-width">
        <span class="organisation-name">{{ organisation.name }}</span>
        @if (currentOrganisation.id === organisation.id) {
          <mat-icon class="icon-16 no-margin">check</mat-icon>
        }
      </div>
    </button>
  }
</mat-menu>
